import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItonicsAuthService } from '../../../services/itonicsAuth.service';
import { CognitoAuthService } from '../../../services/cognitoAuth.service';

@Component({
  selector: 'authorize',
  template: ''
})
export class AuthorizeComponent implements OnInit {
  constructor(
    private itonicsAuthService: ItonicsAuthService,
    private cognitoAuthService: CognitoAuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.tenant && params.state) {
        this.itonicsAuthService.getSamlSignInUrlForClient(params.tenant, params.state).subscribe(
          (url) => (window.location.href = url),
          (err) => {
            window.location.href = this.cognitoAuthService.buildTenantUrl(params.tenant) + '/login?error=' + err;
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user/sign-in/authorize.component.ts